module.exports = __webpack_public_path__ + "static/img/autelLogo.3fb6be00.png";